import React from 'react';

import CardHOC from './Components/CardHOC';
import YesNo from '../../../Types/Components/YesNo';

const YesNoCanvas = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <YesNo question={question} />
  </CardHOC>
}

export default YesNoCanvas;